import PromotorDropDown from './PromotorDropDown';

export default PromotorDropDown;
